// extracted by mini-css-extract-plugin
export default {"list":"Pg_1_5_list__IJKS0","timeBar":"Pg_1_5_timeBar__cxYBx","bar":"Pg_1_5_bar__EkpZZ"};